import { TThunkAction } from '../../../types/redux';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addLike = ({ postId, likeType }: any): TThunkAction<Promise<boolean>> => {
  return async () => {
    return !{ postId, likeType };
  };
};
